export default interface SearchSortingSpec {
    sortOrder: SearchSortOrder;
    sortField: string;
}

export enum SearchSortOrder {
    ASCENDING = "ASCENDING",
    DESCENDING = "DESCENDING"
}